import React from 'react';
import usePersonStore from '../../store/personStore';
import { AdminDashboard } from './AdminDashboard';
import { RetailDashboard } from './RetailDashboard';
import { useNavigate } from 'react-router-dom';

const DashBoard = () => {
  const navigate = useNavigate();

  const showRetailDashboard = usePersonStore(
    (store) => store.showRetailDashboard
  );

  const userRoles = usePersonStore((store) => store.userRoles);
  if (!userRoles.length) {
    navigate('/');
  }

  if (showRetailDashboard) {
    return <RetailDashboard />;
  }

  return <AdminDashboard />;
};

export default DashBoard;
